module.exports = __webpack_public_path__ + "img/LR-videostartseite.c87061cb.jpg";